import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OpenIdVerificationParams } from '@/types/openid';
import { PURGE } from 'redux-persist';

const initialState: Partial<OpenIdVerificationParams> = {
  state: '',
  nonce: '',
  codeVerifier: '',
};

const slice = createSlice({
  name: 'openIdVerification',
  initialState,
  reducers: {
    setOpenIdVerification(
      _,
      action: PayloadAction<Partial<OpenIdVerificationParams>>,
    ) {
      return action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const actions = slice.actions;
export default slice.reducer;
